import {h} from 'ui/Framework';

export default h('svg', {
  width: '17',
  height: '16',
  viewBox: '-1 -1 19 18',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'currentColor'
  }, [
    h('path', {
      d: 'M9.702 2.567L.964 11.306 0 16l4.776-.882 8.739-8.738-3.813-3.813zm-7.754 9.715l7.76-7.759.48.48-7.76 7.76-.48-.48zm1.841 1.853l-.48-.48 7.76-7.76.48.48-7.76 7.76zM14.37 5.526l-3.814-3.813L12.27 0l3.813 3.813z'
    })
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/edit.es6.js